export class AppSettings {
    MaximumDaysForPastActivationDate = 2000;
    MaximumDaysForPastActivationDateExtended = 2000;
    MaximumDaysAllowedForWarrantyReturn = 2000;
    MaximumDaysAllowedForWarrantyReturnExtended = 2000;
    PrePairedWarrantyCards = false;
}
